/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { DeleteRemovePrintExampleFromConfigurationMutationResponse, DeleteRemovePrintExampleFromConfigurationPathParams, DeleteRemovePrintExampleFromConfiguration404 } from "../../models/DeleteRemovePrintExampleFromConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getDeleteRemovePrintExampleFromConfigurationUrl({ configurationId }: { configurationId: DeleteRemovePrintExampleFromConfigurationPathParams["configurationId"] }) {
  const res = { method: 'DELETE', url: `/api/v1/configurations/${configurationId}/print-example` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:configurationId/print-example}
 */
export async function deleteRemovePrintExampleFromConfiguration({ configurationId }: { configurationId: DeleteRemovePrintExampleFromConfigurationPathParams["configurationId"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteRemovePrintExampleFromConfigurationMutationResponse, ResponseErrorConfig<DeleteRemovePrintExampleFromConfiguration404>, unknown>({ method : "DELETE", url : getDeleteRemovePrintExampleFromConfigurationUrl({ configurationId }).url.toString(), ... requestConfig })  
  return res.data
}